import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitiateWithdrawalPopupComponent } from './initiate-withdrawal-popup.component';
import { MatButtonModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from '../../../../tooltip/tooltip.module';



@NgModule({
  declarations: [InitiateWithdrawalPopupComponent],
  imports: [
    CommonModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, MatButtonModule, TooltipModule
  ]
})
export class InitiateWithdrawalPopupModule { }
